<div class="row filter-type-selection-header"></div>
<div class="row filter-type-selection-body">
  <div class="col-12">
    <div class="form-group from-group-nospace-bottom">
      <div id="criteria-row" class="row">
        <div class="col-4">
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              #filterOpcode="ngModel"
              name="filterOptions"
              [(ngModel)]="selectedCompanyCriteria"
              appLabelFloat
              required
            >
              <option *ngFor="let operator of filterOperationOptions" value="{{ operator.value }}">
                {{ operator.label }}
              </option>
            </select>
            <label>Select Criteria Option</label>
          </span>
          <span class="help-block">
            <span *ngIf="validateCriteriaOption"> Please select an Option </span>
          </span>
        </div>
        <div class="col-4">
          <span class="ey-float-label row">
            <input
              class="form-control filter-value"
              #filterValue="ngModel"
              name="filterValue"
              [(ngModel)]="filterByCompanyValue"
              type="text"
              appLabelFloat
              required
            />
            <label>Enter Value</label>
          </span>
          <span class="help-block">
            <span *ngIf="validateCriteriaValue"> Please enter a value </span>
          </span>
        </div>
        <div class="col-4">
          <span class="ey-float-label">
            <select class="form-control form-select" #filterOpcode="ngModel" name="countryOptions" [(ngModel)]="countryId" appLabelFloat required>
              <option *ngFor="let country of filterCountryOptions" value="{{ country.countryId }}">
                {{ country.countryName }}
              </option>
            </select>
            <label>Select Country</label>
          </span>
          <span class="help-block"> </span>
        </div>
      </div>

      <div class="row btn-row">
        <div class="col-12">
          <div class="row">
            <div class="col-9">
              <button type="button" class="btn btn-default reset-button-margin" (click)="resetFilters()">Reset</button>
              <button type="button" class="btn btn-primary" (click)="onCompanyNameSearchClick()">Search</button>
            </div>
            <div class="col-3">
              <span *ngIf="companySearchCount > 0">Search Count : {{ companySearchCount }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="padding-top: 1rem">
        <div class="col-12">
          <p-table
            #tableCompanyFilter
            [value]="companyNameFilterResults"
            dataKey="bvdId"
            [(selection)]="selectedCompanyRows"
            [style]="{ width: '100%' }"
            [lazy]="true"
            (onLazyLoad)="paginate($event)"
            [lazyLoadOnInit]="false"
            (onRowUnselect)="onRowUnselect($event)"
            (onRowSelect)="onRowSelect($event)"
            (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event, companyNameFilterResults)"
            [scrollable]="true"
            scrollHeight="200px"
            [totalRecords]="companyNameFilterResults?.length"
            styleClass="company-name-table"
          >
            <ng-template pTemplate="header" let-columns>
              <tr class="header-row">
                <th class="status-columns-checkbox">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th class="process-decision-companyheader">Company Name</th>
                <!--<th class="status-columns">Search Strategy</th>-->
                <th class="status-columns">Country</th>
                <th class="status-columns">ID Number</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-result>
              <tr class="companyNameGridResult-Row" [pSelectableRow]="result">
                <td class="status-columns-checkbox">
                  <p-tableCheckbox [value]="result"></p-tableCheckbox>
                </td>
                <td class="black-text process-decision-companyname" title="{{ result.companyName }}">{{ result.companyName }}</td>
                <td class="black-text desc-col status-columns">{{ result.countryName }}</td>
                <td class="black-text desc-col status-columns" title="{{ result.bvdId }}">{{ result.bvdId }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="6" class="text-center">No results to display</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      <div class="bottom-row">
        <div class="col-12 companyName-grid-footer">
          <div class="companyName-clearAll-margin">
            <a
              [class.disabled]="
                (this.filter !== undefined &&
                  (this.filter.selectedCompanies === undefined ||
                    this.filter.selectedCompanies === null ||
                    this.filter.selectedCompanies.length <= 0)) === true
                  ? true
                  : null
              "
              (click)="clearSelected()"
              style="color: black"
            >
              <i class="material-icons" style="vertical-align: sub; font-size: 16px">clear_all</i>
              <span
                >Clear Selected <span *ngIf="filter.selectedCompanies?.length">({{ filter.selectedCompanies?.length }})</span></span
              >
            </a>
          </div>
          <div class="bdMatrixPaginator">
            <p-paginator
              #paginator
              [rows]="companyNamePageSize"
              [totalRecords]="companyNameFilterTotalRecords"
              (onPageChange)="paginate($event)"
              #footerPaginator
            ></p-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
